module.exports = __webpack_public_path__ + "img/sebrae-ba-logo.png_color.5bec6d29.png";